// extracted by mini-css-extract-plugin
export default {"avatar":"CandidateProfileAvatar_avatar__oqil2"};